import React, { useState } from 'react';
import { CategoryList } from './CategoryList';
import { CategoryForm } from './CategoryForm';
import { CategoryWithChildren } from './types';
import { useCategories } from './hooks/useCategories';
import './CategoryForm.css';

interface CategoryManagementProps {
  onDirtyChange?: (dirty: boolean) => void;
}

export function CategoryManagement({ onDirtyChange }: CategoryManagementProps) {
  const {
    categories,
    loading,
    error,
    createCategory,
    updateCategory,
    deleteCategory
  } = useCategories();

  const [selectedParentCategory, setSelectedParentCategory] = useState<CategoryWithChildren | null>(null);

  const handleSelectCategory = (category: CategoryWithChildren) => {
    setSelectedParentCategory(category);
  };

  // Update selected parent category when categories are refreshed
  React.useEffect(() => {
    if (selectedParentCategory) {
      const updatedParent = categories.find(cat => cat.id === selectedParentCategory.id);
      if (updatedParent) {
        setSelectedParentCategory(updatedParent);
      }
    }
  }, [categories, selectedParentCategory]);

  const handleSaveSuccess = () => {
    // Categories will be refreshed automatically by the hook
    // The useEffect above will update the selected parent category
  };


  return (
    <div className="app-main">
      <div className="app-sidebar">
        <div className="app-sidebar-section">
          <CategoryList
            categories={categories}
            loading={loading}
            error={error}
            selectedCategoryId={selectedParentCategory?.id}
            onSelectCategory={handleSelectCategory}
            globalLoading={loading}
            loadingMessage="Loading categories..."
          />
        </div>
      </div>

      <div className="app-content">
        <CategoryForm
          selectedParentCategory={selectedParentCategory}
          onCreateCategory={createCategory}
          onUpdateCategory={updateCategory}
          onDeleteCategory={deleteCategory}
          loading={loading}
          onSaveSuccess={handleSaveSuccess}
          onDirtyChange={onDirtyChange}
        />
      </div>
    </div>
  );
}
